import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { ApiService } from "../../api/api.service";
import { VerificationApiData, VerificationListReq } from "../../../_models/verification-request.modal";

@Injectable({
  providedIn: "root",
})
export class VerificationService {
  
  public endpoint: string = "admin";
  constructor(private apiService: ApiService) { }

  getAll(req: VerificationListReq) {
    let params = new HttpParams({
      fromObject: {
        ...(req.page !== undefined && { page: String(req.page) }),
        ...(req.limit !== undefined && { limit: String(req.limit) }),
        ...(req.offset !== undefined && { offset: String(req.offset) }),
        ...(req.status && { status: req.status }),
        ...(req.date_from && { date_from: req.date_from }),
      },
    });

    return this.apiService.get<VerificationApiData>({
      Url: `${this.endpoint}/didit`,
      Params: params,
    });
  }

  updateStatus(sessionId: string, status: "Approved" | "Declined" | string) {
    return this.apiService.patch<any, any>({
      Url: `${this.endpoint}/didit/session/${sessionId}/status`,
      Body: {
        status: status,
      },
    });
  }

  deleteRequest(sessionId: string) {
    return this.apiService.delete<any, any>({
      Url: `${this.endpoint}/didit/session/${sessionId}`,
      Body: null
    });
  }
}
